import React from 'react';
import AbstractListerField from './AbstractListerField';
import {FIELD_WIDTH} from 'MyAccount/Listings/EbayListing/consts';
import {LEVEL_ERROR, LEVEL_WARNING} from 'crazyEditor/components/EditorUI/BaseUI/InlineMessages/InlineNotification';

export default class ListerCustomError extends AbstractListerField {
  render() {
    const {errorText, id} = this.props;
    return (
      <div id={id}>
        {React.cloneElement(React.Children.only(this.props.children), {level: errorText ? LEVEL_ERROR : LEVEL_WARNING})}
      </div>
    );
  }
}

ListerCustomError.defaultProps = {
  width: FIELD_WIDTH.AUTO,
};
